import React, {Component} from 'react';
import {  Button, Row, Col, Form, FormGroup, FormControl, ControlLabel, InputGroup } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import WorkdocStore from '../../stores/WorkdocStore'
import Select from 'react-select'

class SearchCarBox extends Component {

  constructor(props) {
    super(props)
    this.state = {loading:false,data:[],query:'',aff_lists:[],default_aff:this.props.affId,newItem:'',showAdd:'none'}
  }

  componentDidMount() {
    this.loadAffialiateList()
  }

  loadAffialiateList() {
    let {aff_lists,default_aff} = this.state
    let isCheck = false
    WorkdocStore.loadAffialiateList((result)=>{
      result.data.forEach(function(item,index) {
        aff_lists.push({
          value: item.affiliates_id,
          label: item.name
        })

        if (item.affiliates_id===default_aff)
          isCheck = true
      })
      this.setState({aff_lists:aff_lists})

      if (isCheck)
        this.loadAutoAffialiateList(default_aff)
    })
  }

  loadCarRegistrationNo(query) {
    this.setState({loading:true})
    let that = this
    StockStore.loadCarRegistrationNoWithWork(query,function(result) {
      that.setState({loading:false,data:result.data})
    })
  }

  onTextChange(e) {
    this.setState({query:e.target.value})
  }

  onTextKeyPress(e) {
    if (e.charCode == 13) {
      e.preventDefault()
      let {query} = this.state
      this.setState({showAdd:'none',newItem:'',default_aff:''})
      this.loadCarRegistrationNo(query)
    }  
  }

  onSearchClick() {
    let {query} = this.state
    this.setState({showAdd:'none',newItem:'',default_aff:''})
    this.loadCarRegistrationNo(query)
  }

  onAffiliatesChange(e) {
    this.loadAutoAffialiateList(e.value)
    if (this.props.onAffChange!=undefined)
      this.props.onAffChange(e.value)
  }

  loadAutoAffialiateList(value) {
    this.setState({loading:true})
    let items = []
    WorkdocStore.loadAutoAffialiateList(value,(result)=>{
      result.data.forEach(function(item,index) {
        items.push({
          Name: item.affiliates_id,
          Value: item.car_registration_no,
          car_info: '',
          work_no: ''
        })
      })
      this.setState({data:items,loading:false,default_aff:value,showAdd:'',query:'',newItem:''})
    })
  }

  onTextNewItemChange(e) {
    this.setState({newItem:e.target.value})
  }

  onTextNewItemKeyPress(e) {
    if (e.charCode == 13) {
      e.preventDefault()
      
      let {newItem,default_aff} = this.state
      this.setState({showAdd:'',query:''})
      this.saveAffiliate(newItem,default_aff)
    }  
  }

  onSaveAffiliateClick() {
    let {newItem,default_aff} = this.state
    this.setState({showAdd:'',query:''})
    this.saveAffiliate(newItem,default_aff)
  }

  saveAffiliate(newItem,default_aff) {
    this.setState({loading:true})
    let postData = {affiliates_id:default_aff,car_registration_no:newItem}
    WorkdocStore.saveAffiliate(postData,(result)=>{
      this.setState({loading:false})
      this.loadAutoAffialiateList(this.state.default_aff)
    })
  }

  onHideClick() {
    this.props.onHide()
  }

  onRowSelect(item,e) {
    let {default_aff} = this.state
    if(this.props.onSelect!==undefined)
      this.props.onSelect(item,default_aff)
    if(this.props.onHide!==undefined)  
      this.props.onHide()
    this.setState({query:'',data:[]})
  }

  renderSearch(){
    let {query,aff_lists,default_aff} = this.state
    return([
      <Row key={'r0'}>
        <Col md={4}>
          <FormGroup>
            <ControlLabel>ค้นหาทะเบียนรถ</ControlLabel>
          </FormGroup>
        </Col>
        <Col md={8}>
          <Form inline>
            <FormGroup>
              <FormControl style={{width:'200px'}} value={query} onChange={this.onTextChange.bind(this)} onKeyPress={this.onTextKeyPress.bind(this)} />
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Button className='btn' onClick={this.onSearchClick.bind(this)}><FontAwesome name='search' />&nbsp;ค้นหา</Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>,
      <Row key={'r1'}>
        <Col md={4}>
          <FormGroup>
            <ControlLabel>บริษัทในเครือ</ControlLabel>
          </FormGroup>
        </Col>
        <Col md={5}>
            <FormGroup>
                <Select
                  placeholder={'-- เลือกบริษัทในเครือ --'}
                  clearable={false}
                  options={aff_lists}
                  value={default_aff}
                  onChange={this.onAffiliatesChange.bind(this)}
                />
            </FormGroup>
        </Col>
      </Row>
    ])
  }

  renderSearchResult() {
    return(
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center'>หมายเลขทะเบียน</th>
            <th className='text-center'>ใบงาน</th>
            <th className='text-center'>รายละเอียดรถ</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )  
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(
        <tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>
      ) 
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index} onClick={this.onRowSelect.bind(this,item)}>
              <td className='text-center'>{typeof item.car_registration_no!=='undefined'?item.car_registration_no:item.Value}</td>
              <td className='text-center'>{item.work_no}</td>
              <td>{item.car_info}</td>
            </tr>
          )
        })
      )
    }   
  }

  renderButton() {
    let {newItem,showAdd} = this.state
    return(
      <Row style={{marginTop:'20px',display:showAdd}}>
        <Col md={4}>
          <FormGroup>
            <ControlLabel>เพิ่มทะเบียนรถในเครือ</ControlLabel>
          </FormGroup>
        </Col>
        <Col md={8}>
          <Form inline>
            <FormGroup>
              <FormControl style={{width:'200px'}} value={newItem} onChange={this.onTextNewItemChange.bind(this)} onKeyPress={this.onTextNewItemKeyPress.bind(this)} />
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Button className='bg-olive' onClick={this.onSaveAffiliateClick.bind(this)}><FontAwesome name='plus' />&nbsp;เพิ่ม</Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    )
  }

  render(){    
    let {loading} = this.state
    return(
     
        <Box loading={loading}>            
          <Box.Body>
            {this.renderSearch()}
            {this.renderSearchResult()}
            {this.renderButton()}
          </Box.Body>
        </Box> 
        
    )  
  }
}

export default SearchCarBox


// WEBPACK FOOTER //
// ./src/component/element/SearchCarBox.js